<script lang="ts" setup>
import type {
    CollectionFragment,
    MetadataFragment,
    ParentCollectionFragment,
} from '~/lib/graphql/graphql.ts'

const props = defineProps<{
  item: MetadataFragment | CollectionFragment | ParentCollectionFragment | null
  class: string
  relationship?: string | undefined
  style?: string | undefined
  lazy?: boolean | undefined
}>()

const image = computed(() => {
    const relationship = props.relationship
    || (props.item.attributes.type == 'Podcast'
        ? 'image.featured.square'
        : 'image.featured')
    if (props.item?.__typename === 'Collection') {
        return props.item.metadataRelationships?.find(a =>
            a.relationship === relationship,
        )
    }
    if (props.item?.__typename === 'Metadata') {
        return props.item.relationships?.find(a =>
            a.relationship === relationship,
        )
    }
    return null
})
</script>

<template>
  <PPicture
    v-if="image"
    :item="image"
    :lazy="lazy === undefined || lazy"
    :class="props.class"
    :style="props.style"
  />
</template>
